<template>
  <div>
    <el-table ref="specTable" v-loading="loading" style="width: 100%;"
      :class="{ [$style.detailTable]: true, [$style.fullWidth]: fullWidth }" :data="specListFilterSealing">
      <el-table-column v-if="!dialogStatus" type="selection" width="100"></el-table-column>

      <el-table-column label="圖片" width="150">
        <template slot-scope="scope">
          <img v-if="scope.row.params.images[0].path" class="goods-img" :src="scope.row.params.images[0].path" alt="" />
          <img v-else :src="require(`@assets/images/icons/face-cream.svg`)" />
        </template>
      </el-table-column>

      <el-table-column label="商品" width="150">
        <template slot-scope="scope">
          <div class="goods-info">
            <p>{{ scope.row.serviceTitle }}</p>
          </div>
          <div class="goods-info">
            <p>{{ scope.row.petCategory }}</p>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="分店及規格" width="150">
        <template slot-scope="scope">
          <div class="goods-info">
            <p>{{ scope.row.storeTitle }}</p>
          </div>
          <div class="goods-info">
            <p v-for="(spec, index) in scope.row.spec" :key="index">{{ spec.title }}: {{ spec.values[0].title }}</p>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="商品貨號" width="150">
        <template slot-scope="scope">{{ scope.row.no }}</template>
      </el-table-column>

      <el-table-column :label="`商品${purchaseText}數量`" width="150">
        <template slot-scope="scope">
          <el-input v-model="scope.row.inventory" class="goods-amount"></el-input>
        </template>
      </el-table-column>

      <slot></slot>

    </el-table>
  </div>
</template>

<script>
export default {
  name: 'DetailTable',
  props: {
    specList: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
    loading: {
      type: Boolean,
      require: false,
      default: false,
    },
    /**
     * @description 讓資料置中
     */
    fullWidth: {
      type: Boolean,
      require: false,
      default: false,
    },
    /**
     * @description 進貨or退貨的中文字
     */
    purchaseText: {
      type: String,
      require: true,
      default: '',
    },
    /**
     * @description 是否是dialog開啟的
     */
    dialogStatus: {
      type: Boolean,
      require: true,
      default: false,
    }
  },

  computed: {
    selectedInventories() {
      return this.$refs.specTable.selection
    },
    specListFilterSealing() {
      return this.specList.filter(item => item.state !== 2)
    },
  },
  watch: {
    specList(nvl, ovl) {
      console.log(nvl, ovl)
    }
  },
  methods: {
    /**
     * @description 更新 庫存清單
     */
    async updateInventoryList() {
      try {
        if(this.dialogStatus){
          await this.validateInventories(this.specList)
          this.$store.commit('inventory/PUSH_LIST', this.specList)
          this.$emit('closeNoDialogFromDetailTable')
          return 
        }
        if (this.selectedInventories.length > 0) {
          await this.validateInventories(this.selectedInventories)
          this.$store.commit('inventory/PUSH_LIST', this.selectedInventories)
          this.$emit('closeNoDialogFromDetailTable')
        }
        if (this.selectedInventories.length === 0) {
          this.$message({ message: '請勾選一項商品', type: 'error' })
        }
      } catch (error) {
        this.$message({ message: error.message, type: 'error' })
        console.error(error.message)
      }
    },
    /**
     * @description 驗證選到的庫存資料
     */
    async validateInventories(tableData) {
      return new Promise((resolve, reject) => {
        tableData.forEach(item => {
          let result = +item.inventory
          if (isNaN(result) || result < 0) {
            reject(new Error('請輸入正確數量'))
          }
        })
        resolve()
      })
    },
  },
}
</script>

<style lang="scss" module>

.fullWidth {
  :global {
    .el-table__header {
      width: 100% !important;
    }

    .el-table__empty-block {
      width: 100% !important;
    }

    .el-table__body {
      width: 100% !important;
    }
  }
}

.detailTable {
  &::before {
    height: 0;
    display: none;
  }

  :global {


    .goods-img {
      max-width: 80px;
    }

    .goods-info {
      p {
        margin: 0;
      }
    }

    .goods-amount {
      max-width: 100px;
    }

    .el-table__header-wrapper {
      margin-bottom: 10px;
      background-color: #f9f9fb;
    }

    .el-table__body-wrapper {}

    .el-table__row {
      background-color: #f9f9fb;
    }

    th {
      border: none !important;
    }

    .close-icon {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
